import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

const statusColors = {
  open: "default", // $t('open')
  paid: "green", // $t('paid')
  failed: "red", // $t('failed')
  cancelled: "default", // $t('cancelled')
  expired: "orange", // $t('expired')
  pending: "gold", // $t('pending')
  refunded: "purple", // $t('refunded')
  charged_back: "magenta", // $t('charged_back')
};

export function PaymentTag({ status }) {

  const label = {
    open: $t('open'),
    paid: $t('betaald'),
    failed: $t('mislukt'),
    cancelled: $t('geannuleerd'),
    expired: $t('verlopen'),
    pending: $t('open'),
    refunded: $t('terugbetaald'),
    charged_back: $t('teruggeboekt'),
  };
  if (!status) return null;
  const color = statusColors[status] || "default";
  return (
    <Tag color={color} style={{ marginRight: 8, textTransform: "capitalize" }}>
      {label[status] || status}
    </Tag>
  );
}
